export const selectIsTourHovered = state => state.navOnboardingTourHover.isHovered;